import {
    GET_CLAIM_PAYMENTS,
    APPEAL_CLAIM_PAYMENT,
    PAY_IN_FULL_CLAIM,
    PAY_IN_FULL_CLAIM_BILLING,
    EDIT_CLAIM_PAYMENT_INFO,
    CREATE_REMITTANCE,
    GET_REMITTANCE,
    VERIFY_REMITTANCES,
    MARK_REVIEWED_REMITTANCE,
    SYNC_TL_CLEARINGHOUSE_ERAS,
    GET_REMITTANCE_BY_ID,
    EDIT_REMITTANCE,
    VOID_REMITTANCE,
    MASS_VOID_REMITTANCE,
    GET_REMITTANCE_TOTAL,
    REMOVE_CLAIM_FROM_REMITTANCE,
    GET_REMITTANCE_BY_ID_CLAIMS,
    GET_CLAIM_PAYMENT_FILTERED,
    DELETE_REMITTANCE,
} from './claimPayment.type';

/** Claim Payment */

export const createRemittance = (data) => {
    return {
        type: CREATE_REMITTANCE,
        payload: { data },
    };
};
export const editRemittance = (id, data) => {
    return {
        type: EDIT_REMITTANCE,
        payload: { id, data },
    };
};
export const getRemittance = (params, load) => {
    return {
        type: GET_REMITTANCE,
        payload: { params, load },
    };
};
export const verifyRemittance = (ids, singleId) => {
    return {
        type: VERIFY_REMITTANCES,
        payload: { ids, singleId },
    };
};

export const markReviewedRemittance = (ids, reviewNote, singleId) => {
    return {
        type: MARK_REVIEWED_REMITTANCE,
        payload: { ids, reviewNote, singleId },
    };
};

export const syncTlClearinghouseEras = () => {
    return {
        type: SYNC_TL_CLEARINGHOUSE_ERAS,
    };
};

export const getRemittanceById = (id, load) => {
    return {
        type: GET_REMITTANCE_BY_ID,
        payload: { id, load },
    };
};

export const getRemittanceByIdClaims = (id, params, load) => {
    return {
        type: GET_REMITTANCE_BY_ID_CLAIMS,
        payload: { id, params, load },
    };
};
export const voidRemittance = (id, params) => {
    return {
        type: VOID_REMITTANCE,
        payload: { id, params },
    };
};
export const massVoidRemittance = (data) => {
    return {
        type: MASS_VOID_REMITTANCE,
        payload: { data },
    };
};
export const deleteRemittance = (id) => {
    return {
        type: DELETE_REMITTANCE,
        payload: { id },
    };
};

export const getRemittanceTotal = (params) => {
    return {
        type: GET_REMITTANCE_TOTAL,
        payload: { params },
    };
};

export const getClaimPaymentFiltered = (id, data, load) => {
    return {
        type: GET_CLAIM_PAYMENT_FILTERED,
        payload: { id, data, load },
    };
};
export const getClaimPayments = (data, load) => {
    return {
        type: GET_CLAIM_PAYMENTS,
        payload: { data, load },
    };
};

export const editClaimPaymentInfo = (body, getParams, remittanceId, reqParams) => {
    return {
        type: EDIT_CLAIM_PAYMENT_INFO,
        payload: { body, getParams, remittanceId, reqParams },
    };
};

export const appealClaimPayment = (body, getParams, remittanceId) => {
    return {
        type: APPEAL_CLAIM_PAYMENT,
        payload: { body, getParams, remittanceId },
    };
};

export const payInFullClaim = (body, getParams, remittanceId, reqParams) => {
    return {
        type: PAY_IN_FULL_CLAIM,
        payload: { body, getParams, remittanceId, reqParams },
    };
};

export const payInFullClaimBill = (body, getParams, remittanceId, reqParams) => {
    return {
        type: PAY_IN_FULL_CLAIM_BILLING,
        payload: { body, getParams, remittanceId, reqParams },
    };
};
export const removeClaimFromRemittance = (body, reqParams) => {
    return {
        type: REMOVE_CLAIM_FROM_REMITTANCE,
        payload: { body, reqParams },
    };
};

/** End */
